 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"contact":"contact","create_deck~edit_deck~track_game~umdb_deck~user_results":"create_deck~edit_deck~track_game~umdb_deck~user_results","create_deck~edit_deck~umdb_deck":"create_deck~edit_deck~umdb_deck","create_deck":"create_deck","edit_deck~track_game~user_results":"edit_deck~track_game~user_results","track_game":"track_game","user_results":"user_results","deck_list~user_decks":"deck_list~user_decks","deck_list":"deck_list","user_decks":"user_decks","edit_deck~home~posts_section~single_post~umdb_boardlist~umdb_card~umdb_deck~umdb_setlist":"edit_deck~home~posts_section~single_post~umdb_boardlist~umdb_card~umdb_deck~umdb_setlist","umdb_deck":"umdb_deck","edit_deck":"edit_deck","home~posts_section~single_post":"home~posts_section~single_post","home":"home","posts_section":"posts_section","single_post":"single_post","umdb_boardlist":"umdb_boardlist","umdb_card":"umdb_card","umdb_setlist":"umdb_setlist","error":"error","login":"login","privacy":"privacy","report_abuse":"report_abuse","resources":"resources","results_grid":"results_grid","set_username":"set_username","support_the_site":"support_the_site","terms":"terms","umdb":"umdb","umdb_cardlist":"umdb_cardlist","umdb_decklist":"umdb_decklist"}[chunkId]||chunkId) + "." + {"contact":"0b375645","create_deck~edit_deck~track_game~umdb_deck~user_results":"2652bdfb","create_deck~edit_deck~umdb_deck":"fec90789","create_deck":"e49cc82f","edit_deck~track_game~user_results":"da8f5419","track_game":"51b52efa","user_results":"e65516aa","deck_list~user_decks":"df203100","deck_list":"f0453a3c","user_decks":"59e37ece","edit_deck~home~posts_section~single_post~umdb_boardlist~umdb_card~umdb_deck~umdb_setlist":"b8b1bb05","umdb_deck":"73e46111","edit_deck":"4479792d","home~posts_section~single_post":"4fc749a1","home":"cee87839","posts_section":"93db9666","single_post":"32027bf0","umdb_boardlist":"d1799b99","umdb_card":"d2a191fb","umdb_setlist":"a4831b86","error":"acd46afe","login":"7ff2fcba","privacy":"2fe431f9","report_abuse":"a9adf8a8","resources":"da4af3a1","results_grid":"8ccde927","set_username":"6bda81e5","support_the_site":"e1d370e2","terms":"5dc2921d","umdb":"b2479832","umdb_cardlist":"55eed5ee","umdb_decklist":"8cb0a2fd"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"create_deck~edit_deck~umdb_deck":1,"create_deck":1,"edit_deck~track_game~user_results":1,"user_results":1,"deck_list":1,"umdb_deck":1,"edit_deck":1,"home~posts_section~single_post":1,"home":1,"single_post":1,"umdb_boardlist":1,"umdb_card":1,"umdb_setlist":1,"results_grid":1,"umdb_cardlist":1,"umdb_decklist":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"contact":"contact","create_deck~edit_deck~track_game~umdb_deck~user_results":"create_deck~edit_deck~track_game~umdb_deck~user_results","create_deck~edit_deck~umdb_deck":"create_deck~edit_deck~umdb_deck","create_deck":"create_deck","edit_deck~track_game~user_results":"edit_deck~track_game~user_results","track_game":"track_game","user_results":"user_results","deck_list~user_decks":"deck_list~user_decks","deck_list":"deck_list","user_decks":"user_decks","edit_deck~home~posts_section~single_post~umdb_boardlist~umdb_card~umdb_deck~umdb_setlist":"edit_deck~home~posts_section~single_post~umdb_boardlist~umdb_card~umdb_deck~umdb_setlist","umdb_deck":"umdb_deck","edit_deck":"edit_deck","home~posts_section~single_post":"home~posts_section~single_post","home":"home","posts_section":"posts_section","single_post":"single_post","umdb_boardlist":"umdb_boardlist","umdb_card":"umdb_card","umdb_setlist":"umdb_setlist","error":"error","login":"login","privacy":"privacy","report_abuse":"report_abuse","resources":"resources","results_grid":"results_grid","set_username":"set_username","support_the_site":"support_the_site","terms":"terms","umdb":"umdb","umdb_cardlist":"umdb_cardlist","umdb_decklist":"umdb_decklist"}[chunkId]||chunkId) + "." + {"contact":"31d6cfe0","create_deck~edit_deck~track_game~umdb_deck~user_results":"31d6cfe0","create_deck~edit_deck~umdb_deck":"0da3c62a","create_deck":"f5416b4b","edit_deck~track_game~user_results":"5b2d6e0c","track_game":"31d6cfe0","user_results":"876407bd","deck_list~user_decks":"31d6cfe0","deck_list":"c0f163a4","user_decks":"31d6cfe0","edit_deck~home~posts_section~single_post~umdb_boardlist~umdb_card~umdb_deck~umdb_setlist":"31d6cfe0","umdb_deck":"5e7048d4","edit_deck":"f5a68dc4","home~posts_section~single_post":"6b114345","home":"b75d00b5","posts_section":"31d6cfe0","single_post":"3b09a8ab","umdb_boardlist":"4e5dbc85","umdb_card":"bca9b396","umdb_setlist":"4e5dbc85","error":"31d6cfe0","login":"31d6cfe0","privacy":"31d6cfe0","report_abuse":"31d6cfe0","resources":"31d6cfe0","results_grid":"ac9ab28d","set_username":"31d6cfe0","support_the_site":"31d6cfe0","terms":"31d6cfe0","umdb":"31d6cfe0","umdb_cardlist":"b38de14e","umdb_decklist":"fc267da2"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
